import { Box, Group, Text, ThemeIcon, UnstyledButton, useMantineTheme } from "@mantine/core";
import { useLiveQuery } from "dexie-react-hooks";
import { type ChatEntity, db } from "../db";

interface MainLinkProps {
    icon: React.ReactNode;
    chat: ChatEntity;
    isHighlighted: boolean;
}

export function MainLink({ icon, chat, isHighlighted }: Readonly<MainLinkProps>) {
    const theme = useMantineTheme();
    const color = isHighlighted ? theme.colors.purple[4] : "black";
    const variant = isHighlighted ? "dark" : "subtle";
    const textColor = isHighlighted ? "white" : "black";
    const firstMessage = useLiveQuery(async () => {
        return (await db.messages.orderBy("createdAt").toArray()).filter(
            (m) => m.chatId === chat.id,
        )[0];
    }, [chat]);

    return (
        <UnstyledButton
            style={(theme) => ({
                // display: "block",
                width: "100%",
                padding: theme.spacing.xs,
                borderRadius: theme.radius.sm,
                color,
            })}
        >
            <Group>
                <ThemeIcon variant={variant} color={color}>
                    {icon}
                </ThemeIcon>
                <Box
                    style={{
                        textOverflow: "ellipsis",
                        color: textColor,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        flex: 1,
                        width: 0,
                    }}
                >
                    <Text size="xs">
                        <strong>{firstMessage?.content}</strong>
                    </Text>

                    <Text size="xs">
                        {typeof firstMessage?.createdAt === "number"
                            ? new Intl.RelativeTimeFormat("en", { numeric: "auto" }).format(
                                  Math.round(
                                      (firstMessage.createdAt - Date.now()) / (1000 * 60 * 60 * 24),
                                  ),
                                  "day",
                              )
                            : typeof firstMessage?.createdAt === "object"
                              ? new Intl.RelativeTimeFormat("en", { numeric: "auto" }).format(
                                    Math.round(
                                        // @ts-expect-error
                                        (firstMessage.createdAt?.getTime() - Date.now()) /
                                            (1000 * 60 * 60 * 24),
                                    ),
                                    "day",
                                )
                              : firstMessage?.createdAt}
                    </Text>
                </Box>
            </Group>
        </UnstyledButton>
    );
}
